import MerchantApi from "@/api/MerchantApi";

const MerchantStore = {
  namespaced: true,
  state: {
    merchantList: [],
  },
  mutations: {
    setMerchantList(state, data) {
      state.merchantList = data;
    },
  },
  actions: {
    listMerchant(ctx, data) {
      return MerchantApi.listMerchant(data);
    },
    listAllMerchant(ctx, data) {
      data = data || {};
      if (!data.isUpdate && ctx.state.merchantList.length > 0) {
        return Promise.resolve(ctx.state.merchantList);
      }
      return MerchantApi.listAllMerchant(data).then((res) => {
        let merchantList = [];
        res.items.forEach((item) => {
          merchantList.push({
            value: item.id,
            label: item.merchantName,
          });
        });
        ctx.commit("setMerchantList", merchantList);
        return res;
      });
    },

    addOrModifyMerchant(ctx, data) {
      return MerchantApi.addOrModifyMerchant(data).then((res) => {
        ctx.dispatch("listAllMerchant", { isUpdate: true });
        return res;
      });
    },

    merchantBindEnterprise(ctx, data) {
      return MerchantApi.merchantBindEnterprise(data);
    },
  },
};

export default MerchantStore;
